import React from "react";
import CustomizedAvatar from "../../commons/CircularAvatar/CustomizedAvatar";
import "./style.scss"

type AppProps = {
  singlePeDetailsList: any;
};
const FeedbackDetailData = ({ singlePeDetailsList }: AppProps) => {
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;
  return (
    <>
      <div
        style={{
          border: "1px solid #bfcbe1",
          padding: "20px 30px 20px 20px",
          marginLeft: "25px",
          marginTop: "25px",
          width: "92%",
          borderRadius: "5px",
        }}
      >
        <div
          style={{ fontSize: "16px", fontWeight: "500", marginBottom: "13px" }}
        >
          {" "}
          Employee Details
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div>
            <CustomizedAvatar
              name={`${
                singlePeDetailsList?.created_by?.first_name
                  ? singlePeDetailsList?.created_by?.first_name
                  : ""
              } ${
                singlePeDetailsList?.created_by?.last_name
                  ? singlePeDetailsList?.created_by?.last_name
                  : ""
              }`}
              image={
                singlePeDetailsList?.created_by?.profile_pic?.file_url &&
                singlePeDetailsList?.created_by?.profile_pic?.file_url
              }
              style={{ width: "60px", fontSize: "15px" }}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              style={{
                color: "#262a44",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              {`${singlePeDetailsList?.created_by?.first_name} ${singlePeDetailsList?.created_by?.last_name}`}
            </div>
            <span
              style={{
                color: "#6e7491",
                fontWeight: "500",
                fontSize: "13px",
              }}
            >
              {`${
                singlePeDetailsList?.created_by?.job_title
                  ? singlePeDetailsList?.created_by?.job_title
                  : ""
              }`}
            </span>
            <span
              style={{
                color: "#6e7491",
                fontWeight: "500",
                fontSize: "13px",
              }}
            >
              {`${
                singlePeDetailsList?.created_by?.department
                  ? singlePeDetailsList?.created_by?.department
                  : ""
              }`}
            </span>
          </div>
        </div>
        <div
          className="mt-4"
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontWeight: "500",
                fontSize: "13px",
                marginBottom: "5px",
              }}
            >
              Employee ID
            </span>

            <span
              style={{
                color: "#262a44",
                fontWeight: "normal",
                fontSize: "14px",
              }}
            >
              {singlePeDetailsList?.created_by?.employee_id
                ? singlePeDetailsList?.created_by?.employee_id
                : "NA"}
            </span>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontWeight: "500",
                fontSize: "13px",
                marginBottom: "5px",
              }}
            >
              Reporting To
            </span>
            <div
              className="d-flex"
              style={{ gap: "5px", alignItems: "center" }}
            >
              <div>
                {singlePeDetailsList?.created_by?.reporting_person
                  ?.first_name ? (
                  <CustomizedAvatar
                    name={`${
                      singlePeDetailsList?.created_by?.reporting_person
                        ?.first_name
                        ? singlePeDetailsList?.created_by?.reporting_person
                            ?.first_name
                        : ""
                    } ${
                      singlePeDetailsList?.created_by?.reporting_person
                        ?.last_name
                        ? singlePeDetailsList?.created_by?.reporting_person
                            ?.last_name
                        : ""
                    }`}
                    image={
                      singlePeDetailsList?.created_by?.reporting_person
                        ?.profile_pic?.file_url &&
                      singlePeDetailsList?.created_by?.reporting_person
                        ?.profile_pic?.file_url
                    }
                    style={{ width: "30px", fontSize: "10px" }}
                  />
                ) : (
                  ""
                )}
              </div>
              <div
                style={{
                  color: "#262a44",
                  fontWeight: "normal",
                  fontSize: "14px",
                }}
              >
                {singlePeDetailsList?.created_by?.reporting_person?.first_name
                  ? singlePeDetailsList?.created_by?.reporting_person
                      ?.first_name
                  : "NA"}
              </div>
            </div>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontWeight: "500",
                fontSize: "13px",
                marginBottom: "5px",
              }}
            >
              Joining Date
            </span>

            <span
              style={{
                color: "#262a44",
                fontWeight: "normal",
                fontSize: "14px",
              }}
            >
              {singlePeDetailsList?.created_by?.joining_date
                ? singlePeDetailsList?.created_by?.joining_date
                : "NA"}
            </span>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontWeight: "500",
                fontSize: "13px",
                marginBottom: "5px",
              }}
            >
              Job Location
            </span>

            <span
              style={{
                color: "#262a44",
                fontWeight: "normal",
                fontSize: "14px",
              }}
            >
              {singlePeDetailsList?.created_by?.branch_name
                ? singlePeDetailsList?.created_by?.branch_name
                : "NA"}
            </span>
          </div>
        </div>
      </div>
      <p
        className="ml-4 title"
      >
        Submitted PE Details
      </p>
      <div className="row" style={{ marginLeft: "20px" }}>
        <div className="col-md-4 p-1">
          <label
            className="mb-1 detail-label"
            htmlFor="Response"
          >
            Title
          </label>
          <p>
            {singlePeDetailsList?.title ? singlePeDetailsList?.title : "NA"}
          </p>
        </div>
        <div className="col-md-3 pt-1 pb-1">
          <label
            className="mb-1 detail-label"
            htmlFor="Stage"
          >
            Total Hours Spent
          </label>
          <p>
            {singlePeDetailsList?.hours ? singlePeDetailsList?.hours : "NA"}
          </p>
        </div>
        <div className="col-md-4 pt-1 pb-1">
          <label
            className="mb-1 detail-label"
            htmlFor="Stage"
          >
            Manager
          </label>
          <div className="d-flex" style={{ gap: "5px", alignItems: "center" }}>
            <div>
              {singlePeDetailsList?.manager?.first_name ? (
                <CustomizedAvatar
                  name={`${
                    singlePeDetailsList?.manager?.first_name
                      ? singlePeDetailsList?.manager?.first_name
                      : ""
                  } ${
                    singlePeDetailsList?.manager?.last_name
                      ? singlePeDetailsList?.manager?.last_name
                      : ""
                  }`}
                  image={
                    singlePeDetailsList?.manager?.profile_pic?.file_url &&
                    singlePeDetailsList?.manager?.profile_pic?.file_url
                  }
                  style={{ width: "30px", fontSize: "10px" }}
                />
              ) : (
                ""
              )}
            </div>
            <div
              style={{
                color: "#262a44",
                fontWeight: "normal",
                fontSize: "14px",
              }}
            >
               {`${
                    singlePeDetailsList?.manager?.first_name
                      ? singlePeDetailsList?.manager?.first_name
                      : ""
                  } ${
                    singlePeDetailsList?.manager?.last_name
                      ? singlePeDetailsList?.manager?.last_name
                      : ""
                  }`}
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-1" style={{ marginLeft: "20px" }}>
        <div className="col-md-4 p-1">
          <label
            className="mb-1 detail-label"
            htmlFor="Response"
          >
            Date Range
          </label>
          <p>
            {`${singlePeDetailsList?.start_date} to ${singlePeDetailsList?.end_date}`}
          </p>
        </div>
        <div className="col-md-3 pt-1 pb-1">
          <label
            className="mb-1 detail-label"
            htmlFor="Stage"
          >
            Uploaded by Employee
          </label>
          <div className="file-upload">
            {singlePeDetailsList?.file_attachment?.length > 0 ? (
              singlePeDetailsList?.file_attachment?.map(
                (file: any, index: number) => (
                  <div key={index}>
                    <a
                    href={file?.file_url ? `${blobBaseUrl}${file?.file_url}?${blobToken}`:''}
                      target="_blank"
                      style={{ cursor: "pointer", color: "#007bff" }}
                    >
                      {file?.file_name}
                    </a>
                  </div>
                )
              )
            ) : (
              <span>NA</span>
            )}
          </div>
        </div>
        <div className="col-md-4 pt-1 pb-1">
          <label
            className="mb-1 detail-label"
            htmlFor="Stage"
          >
            Uploaded by Manager
          </label>
          <div className="file-upload">
            {singlePeDetailsList?.manager_file_attachment?.length > 0 ? (
              singlePeDetailsList?.manager_file_attachment?.map(
                (file: any, index: number) => (
                  <div key={index}>
                    <a
                    href={file?.file_url ? `${blobBaseUrl}${file?.file_url}?${blobToken}`:''}
                      target="_blank"
                      style={{ cursor: "pointer", color: "#007bff" }}
                    >
                      {file?.file_name}
                    </a>
                  </div>
                )
              )
            ) : (
              <span>NA</span>
            )}
          </div>
        </div>
      </div>
      <p
        className="ml-4 title"
      >
        PE Feedback
      </p>
      <div className="">
        <div style={{ width: "60%", marginLeft: "25px" }}>
          <label
            className="mb-1 detail-label"
            htmlFor="Response"
          >
            PE Comment
          </label>
          <p>{singlePeDetailsList?.feedback}</p>
        </div>
      </div>
      <div className="">
        <div style={{ marginLeft: "25px", paddingTop: "5px" }}>
          <label
            className="mb-1 detail-label"
            htmlFor="Response"
          >
            Rating
          </label>
          <p>
            {singlePeDetailsList?.rating === 1
              ? "1 - Outstanding performer."
              : singlePeDetailsList?.rating === 2
              ? "2 - Exceeding expectations."
              : singlePeDetailsList?.rating === 3
              ? "3- Meeting all expectations."
              : singlePeDetailsList?.rating === 4
              ? "4 - Not meeting expectations."
              : singlePeDetailsList?.rating === 5?
              "5 - Issues in work performance and have to let go.":""}
          </p>
        </div>
      </div>
    </>
  );
};

export default FeedbackDetailData;
